import MarkdownIt from 'markdown-it';

const markdown = new MarkdownIt({
  html: false,
  breaks: true,
  linkify: true,
});

export function renderMarkdown(text: string): DocumentFragment {
  const template = document.createElement('template');
  template.innerHTML = markdown.render(text);

  for (const link of template.content.querySelectorAll('a')) {
    link.target = '_blank';
    link.rel = 'noreferrer noopener';
  }

  return template.content.cloneNode(true) as DocumentFragment;
}
